import {axiosInstance} from "./axios";

export const getUserToken = () => axiosInstance.get('/get-user-token');

export const saveVisit = (day) => {
    if (day) {
        axiosInstance.post('/visits', {
            day: day,
            userhash: localStorage.getItem("token"),
            edm_id: window.location.href.split('#edm=')[1]
        });
    }
}

export const saveVote = (voteId, option) => {
    axiosInstance.post('/vote', {
        vote_id: voteId,
        vote_option: option,
        userhash: localStorage.getItem("token")
    });
}

export const isVoted = (voteId, successHandler) => {
    axiosInstance.get(`/is-voted?vote_id=${voteId}&userhash=${localStorage.getItem("token")}`).then((response) => {
        successHandler(response);
    }).catch((err) => {
        console.log(err)
    });
}

export const getVotes = (voteId, successHandler) => {
    axiosInstance.get(`/get-votes?vote_id=${voteId}`).then((response) => {
        successHandler(response);
    }).catch((err) => {
        console.log(err)
    });
}


